import React from 'react'
import { spacing } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'

interface PublishDataGridRowProps {
  attributeName: React.ReactNode
  campField: React.ReactNode
  required: React.ReactNode
  actions: React.ReactNode[]
}

const Cell = styled.div({
  display: 'flex',
  flexDirection: 'row',
  height: spacing.X40,
  alignItems: 'center',
})

const PublishDataGridRow: React.FC<PublishDataGridRowProps> = ({
  attributeName,
  campField,
  actions,
  required,
}) => (
  <>
    <Cell>{attributeName}</Cell>
    <Cell>{campField}</Cell>
    <Cell>{required}</Cell>
    <Cell>{actions}</Cell>
  </>
)

export default PublishDataGridRow
